import axios from 'axios';

const cepAlternativeApi = axios.create({
  baseURL: `https://ws.apicep.com/cep`
});

export default cepAlternativeApi;
